'use client';

import { Routes } from '@/settings/routes';
import { useAuth } from '@/hooks/auth';
import Link from 'next/link';
import { FaArrowRight, FaChevronDown, FaChevronUp, FaGaugeHigh, FaPowerOff } from 'react-icons/fa6';

export default function FrontOfficeAdminBar({ isVisible = true, onToggleVisibility = null }) {
    const { user, isLoading, logout } = useAuth();

    if (isLoading || !user) {
        return null;
    }

    if (!isVisible) {
        return (
            <div className="sticky top-0 z-[70] flex justify-end px-4 pt-3 pointer-events-none lg:px-6">
                <button
                    type="button"
                    onClick={() => onToggleVisibility?.()}
                    className="inline-flex gap-2 items-center px-4 py-2 text-sm font-semibold text-white rounded-full shadow-lg border border-[#313041]/10 bg-[#313041] transition-colors pointer-events-auto hover:bg-[#262433]"
                >
                    <FaChevronDown className="w-3 h-3" />
                    Show Admin Bar
                </button>
            </div>
        );
    }

    return (
        <div className="sticky top-0 z-[70] border-b border-[#313041]/10 bg-[#313041] text-white">
            <div className="flex flex-col gap-3 px-4 py-3 mx-auto w-full max-w-8xl lg:px-6 sm:flex-row sm:justify-between sm:items-center">
                <div className="flex flex-col gap-1 sm:flex-row sm:gap-3 sm:items-center">
                    <span className="text-xs font-semibold tracking-[0.2em] uppercase text-orange-200">Admin Mode</span>
                    <span className="text-sm text-white/80">You are browsing the front office as {user?.user_name || user?.email || 'Dashboard User'}.</span>
                </div>

                <div className="flex flex-wrap gap-2 items-center">
                    <Link
                        href={Routes.DASHBOARD}
                        className="inline-flex gap-2 items-center px-4 py-2 text-sm font-semibold text-[#313041] rounded-full bg-white transition-colors hover:bg-orange-50"
                    >
                        <FaGaugeHigh className="w-3.5 h-3.5 text-main-color" />
                        Dashboard
                        <FaArrowRight className="w-3 h-3 text-main-color" />
                    </Link>
                    <button
                        type="button"
                        onClick={logout}
                        className="inline-flex gap-2 items-center px-4 py-2 text-sm font-semibold text-white rounded-full border border-white/15 bg-transparent transition-colors hover:bg-white/10"
                    >
                        <FaPowerOff className="w-3.5 h-3.5" />
                        Logout
                    </button>
                    <button
                        type="button"
                        onClick={() => onToggleVisibility?.()}
                        className="inline-flex gap-2 items-center px-4 py-2 text-sm font-semibold text-white rounded-full border border-white/15 bg-transparent transition-colors hover:bg-white/10"
                    >
                        <FaChevronUp className="w-3.5 h-3.5" />
                        Hide Bar
                    </button>
                </div>
            </div>
        </div>
    );
}
